export default "__VITE_ASSET__BbeJnYmc__"